var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEstale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6625_54076)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.84912 7.15687V15.8069H8.72011V4.04297C8.72011 4.04297 3.59873 6.7592 2.84912 7.15687ZM5.45925 14.3223H3.82175V12.7258H5.45925V14.3223ZM5.45925 12.1462H3.82175V10.5498H5.45925V12.1462ZM5.45925 9.97022H3.82175V8.37377H5.45925V9.97022ZM7.74772 14.3223H6.11023V12.7258H7.74772V14.3223ZM7.74772 12.1462H6.11023V10.5498H7.74772V12.1462ZM7.74772 9.97022H6.11023V8.37377H7.74772V9.97022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06909 0V15.8067H14.9401V3.1139C14.1905 2.71623 9.06909 0 9.06909 0ZM10.0417 4.18198H11.6792V5.77843H10.0417V4.18198ZM10.0417 6.35801H11.6792V7.95446H10.0417V6.35801ZM10.0417 8.53404H11.6792V10.1305H10.0417V8.53404ZM10.0417 10.7101H11.6792V12.3065H10.0417V10.7101ZM13.9677 12.3065H12.3302V10.7101H13.9677V12.3065ZM13.9677 10.1305H12.3302V8.53404H13.9677V10.1305ZM13.9677 7.95446H12.3302V6.35801H13.9677V7.95446ZM13.9677 5.77843H12.3302V4.18198H13.9677V5.77843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875 16.0016H16.875V15.6875H0.875V16.0016Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6625_54076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstale);
export default __webpack_public_path__ + "static/media/estale.73b845d1624030dae9d523d3987b5424.svg";
export { ForwardRef as ReactComponent };